import { render, staticRenderFns } from "./PlayerAvatar.vue?vue&type=template&id=cd5d18ba&scoped=true"
import script from "./PlayerAvatar.vue?vue&type=script&lang=js"
export * from "./PlayerAvatar.vue?vue&type=script&lang=js"
import style0 from "./PlayerAvatar.vue?vue&type=style&index=0&id=cd5d18ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd5d18ba",
  null
  
)

export default component.exports